export default __webpack_public_path__ + "static/media/notification-3.ce760789.mp3";